<template>
   <div class="data-view">
      <div class="string" v-if="['string','number','boolean'].includes(typeof data)">
         {{data}}
      </div>
      <div class="object" v-if="typeof data === 'object' && !Array.isArray(data)">
         <div class="object-item" v-for="(obj,i) of Object.entries(data)" :key="i">
            <div class="simple" v-if="['string','number','boolean'].includes(typeof obj[1])">
               <div class="clearfix">
                  <div class="key">{{formatKeyName(obj[0])}}</div>
                  <div class="val" >
                     {{obj[1]}}
                  </div>
               </div>
            </div>
            <div class="wrapper" 
               :class="object_keys[obj[0]] ? 'expanded' : ''"
               v-else
            >
               <div class="clearfix">
                  <div 
                     @click="toggleObject(obj[0])"
                     class="key"
                     :class="object_keys[obj[0]] ? 'expanded' : ''"
                  >
                     <i class="fa fa-chevron-right" v-if="!object_keys[obj[0]]"></i>
                     <i class="fa fa-chevron-down" v-if="object_keys[obj[0]]"></i>
                     <div class="txt">{{formatKeyName(obj[0])}}</div>
                  </div>
                  <div class="folded" v-if="object_keys[obj[0]] == false && !Array.isArray(obj[1])">{ . . .}</div>
                  <div class="folded" v-if="object_keys[obj[0]] == false && Array.isArray(obj[1])"><b>{{obj[1].length}}</b> Items</div>
                  <transition name="fade">
                     <div class="val full" v-if="object_keys[obj[0]] == true">
                        <dataview :data="obj[1]"/>
                     </div>
                  </transition>
               </div>
            </div>
         </div>
      </div>
      <div class="array" v-if="typeof data === 'object' && Array.isArray(data)">
         <div class="array-item" v-for="(item,j) in data" :key="j">
            <div v-if="typeof item === 'object'">
               <div class="clearfix">
                  <div class="index key full" @click="toggleArray(j)">
                     <i class="fa fa-chevron-right" v-if="!expanded_arr[j]"></i>
                     <i class="fa fa-chevron-down" v-if="expanded_arr[j]"></i>
                     <div class="txt">
                        Item - <b>[{{j}}]</b>
                     </div>
                  </div>
               </div>
               <div class="item" v-if="expanded_arr[j]">
                  <dataview :data="item"/>
               </div>
            </div>
            <div v-else>
               <dataview :data="item"/>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'dataview',
   props:{
      data: {
         default: function(){
            return {}
         }
      },
   },
   watch:{
      // data(){
      //    this.generateFoldedKeys(this.data)
      // }
   },
   created() {
      this.generateFoldedKeys(this.data)
   },
   data() {
      return {
         object_keys: {},
         expanded_arr: []
      }
   },
   methods: {
      formatKeyName(key){
         return key.replace(/_/g, ' ').replace(/[^a-zA-Z ]/g, "").replace(/\b\w/g, function(c) {
            return c.toUpperCase();
         });
      },
      generateFoldedKeys(){
         if(Array.isArray(this.data)){
            this.expanded_arr = []

            for (let i = 0; i < this.data.length; i++) {
               this.expanded_arr.push(false)
            }
         }else{
            for (const [key,val] of Object.entries(this.data)) {
               if(typeof val === 'object'){
                  this.object_keys[key] = false
               }
            }
         }
      },
      toggleObject(key){
         this.object_keys[key] = !this.object_keys[key]
         this.$forceUpdate();
      },
      toggleArray(index){
         this.expanded_arr[index] = !this.expanded_arr[index]
         this.$forceUpdate();
      },
   },
   mounted(){

   }
}
</script>